import React from "react";
import { generatePath, useHref, useParams } from "react-router";
import { CopyIcon, Toast } from "@sscs/ui";
import { ActionMenu } from "Components";
import { FULL_INSIGHTS_PATH } from "Constants";
import { useDialog } from "Hooks";
import { ActionItem } from "Types";
import { MyInsightsSearch } from "../../types";
import DeleteSearch from "../DeleteSearch/DeleteSearch";
import RenameSearch from "../RenameSearch/RenameSearch";

type SearchLabelProps = { search: MyInsightsSearch };

const SearchMenu = ({ search }: SearchLabelProps): React.JSX.Element => {
  const { groupId } = useParams();
  const deleteDialog = useDialog();
  const renameDialog = useDialog();
  const searchLinkPath = useHref(
    `/${generatePath(FULL_INSIGHTS_PATH, {
      searchId: search.id,
      groupId: groupId ?? "",
    })}`,
  );

  const actions: ActionItem[] = [
    {
      id: "rename-search",
      type: "EDIT",
      text: "Rename search",
      onClick: renameDialog.open,
    },
    {
      id: "delete-search",
      type: "DELETE",
      text: "Delete search",
      onClick: deleteDialog.open,
    },
    {
      id: "copy-search-link",
      type: "CUSTOM",
      text: "Copy search link",
      onClick: async () => {
        await navigator.clipboard.writeText(
          `${window.location.origin}${searchLinkPath}`,
        );
        Toast.show({
          title: `${search.name} copied successfully!`,
          type: "success",
        });
      },
      itemIcon: <CopyIcon />,
    },
  ];

  return (
    <>
      <ActionMenu id={`actions-${search.id}`} items={actions} size="small" />
      <RenameSearch
        search={search}
        isOpen={renameDialog.isOpen}
        onClose={renameDialog.close}
      />
      <DeleteSearch
        search={search}
        isOpen={deleteDialog.isOpen}
        onClose={deleteDialog.close}
      />
    </>
  );
};

export default SearchMenu;
